"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shade = void 0;
var SHADES = ['#fff',
// 0
'#d6d6d6',
// 1
'#c2c2c2',
// 2
'#aeaeae',
// 3
'#9a9a9a',
// 4
'#868686',
// 5
'#727272',
// 6
'#5e5e5e',
// 7
'#4a4a4a',
// 8
'#343434' // 9
];

var shade = function shade(color, _shade) {
  return SHADES[_shade] || color;
};
exports.shade = shade;